<template>
   <div class="tabsViews_box" style="height:34px;border-bottom:1px solid #d2d2d2;margin-bottom:16px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 0 3px 2px rgba(103,103, 103, 0.1);">
        <scroll-pane ref="scrollPane" class="tags-view-wrapper" >
            <el-tag
                style="margin: 4px 0px 4px 7px;"
                class="cursors"
                size="small"
                :effect="isActive == tag.path ? 'dark':'plain'"
                v-for="tag in dynamicTags"
                :key="tag.meta.index"
                :closable ="tag.meta.name == '首页'? false: true"
                :disable-transitions="true"
                @click="handleClick(tag)"
                @close="handleClose(tag)">
                {{tag.meta.name}}
            </el-tag>
        </scroll-pane>
   </div>
</template>
<script>
import ScrollPane from "./ScrollPane";
import Sortable from 'sortablejs'
import { mapState, mapMutations, mapActions } from "vuex";
export default {
    name:"tabsViews",
    components: { ScrollPane },
    computed:{
        dynamicTags(){
            return this.$store.state.visitedViews;
        },
        cachedViews(){
            return this.$store.state.cachedViews;
        }
    },
    watch:{
        $route(val){
            let a = {
                meta: val.meta,
                name: val.name,
                path: val.path,
            };
            // 存值Tabs
            let tabArr = [];
            Object.assign(tabArr,this.dynamicTags);
            //先判断是否不需要缓存的，不需要缓存的也不会需要tabs
            if (this.noCacheArr.some(v => v === a.name)) return
            this.isActive = val.path;
            //判断当前的路由是否存在过
            if (tabArr.some(v => v.path === val.path)) return
            tabArr.push(a);
            //增加最多可开 10 个页面
            if(tabArr.length > 10){
                tabArr.splice(1,1);
            }
            this.saveVisitedViews(tabArr);

            //存值缓存 
            let currentName = _.map(tabArr,'name');
            //删除home页，首页不需要缓存
            if(currentName.indexOf('home') != -1){
                currentName.splice(currentName.indexOf('home'),1);
            }
            this.saveCachedViews(currentName); // 存值
        },
        isActive(val){
            this.saveLogUrl(val);
        }
    },
    data(){
        return{
            //不需要缓存的
            noCacheArr : ['batchList','Newpo','purchaseOrderDetails','warehousingDetails','outboundDetails','returnDetails','commodityInfoBuy',
            'orderingModules','batchsNotes','smsOrderS','renewCom','cardStack','cardDetails','reductionUpload','smsRenOrSub'
            ,'qpoolDetails','SingleCard','cardSupplement','userpoolCardXq','buyingCards','userWarn','buyingModule','setDiscount','ViewSubordinates',
            'channelFunc','filePrintings','channelDetails','qualificUp','TempSMS','ThirdParty','TempNoSMS','TempPostpaidSMS','TempPostpaid','TempModule'
            ,'TempModuleCard','contractProcess','TemPurchase','inventoryDetails','homeRewCum'],
            isActive:'', //当前的路由
        }
    },
    mounted(){
        let tabArr = [{
            meta: {index: 3, name: "首页"},
            name: "home",
            path: "/home",
        }];
        this.saveVisitedViews(tabArr); // 存值
        this.saveCachedViews(''); // 存值
        this.isActive = '/home';
        this.rowDrop();
    },
    methods:{
        ...mapActions([  
            'saveVisitedViews','saveCachedViews','saveLogUrl'
        ]),
        handleClose(tag) {
            //删除
            let tabArr =[];
            Object.assign(tabArr,this.dynamicTags);
            tabArr.splice(tabArr.indexOf(tag), 1);
            this.saveVisitedViews(tabArr); // 存值
            this.saveCachedViews(_.map(tabArr,'name')); // 存值
            //删除当前的tabs,路由跳转到最后一个，否则不跳转
            if(this.isActive == tag.path){
                //获取最后一个
                const latestView = tabArr.slice(-1)[0];
                if (latestView) {
                    //跳转到最后一个
                    this.$router.push(latestView.path);
                }
            }
        },
        handleClick(tag){
            //跳转对应的路由
            this.$router.push(tag.path)
        },
        /**
         * 拖拽方法(页面上方打开的菜单，添加拖拽事件)
         */
        rowDrop() {
            const el = document.querySelector('.tags-view-wrapper .el-scrollbar__wrap .el-scrollbar__view'); // 找到想要拖拽的那一列
            const _this = this;
            Sortable.create(el, {
                swapThreshold: 1,
                animation: 150, 
                onEnd({ newIndex, oldIndex }) {
                    let tabArr =[];
                    Object.assign(tabArr, _this.dynamicTags);
                    const currRow = tabArr.splice(oldIndex, 1)[0]
                    tabArr.splice(newIndex, 0, currRow)

                    _this.saveVisitedViews(tabArr); // 存值
                    _this.saveCachedViews(_.map(tabArr,'name')); // 存值
                }
            });
        },
    }
}
</script>
<style>
.tabsViews_box .el-tag--plain{
    background-color: #fff !important;
    border-color: #e4e4e4 !important;
    color: #7d7e7f !important;
}
.tabsViews_box .el-tag--plain .el-tag__close{
    color: #7d7e7f !important;
}
</style>


// WEBPACK FOOTER //
// src/components/tabsViews.vue